import React from 'react';
import BlueDotsBackground from '../BlueDotsBackground';
import Hero from '../components/Hero';
import HeroVideo from '../components/HeroVideo';
import Solutions from '../components/Solutions';
import Differentiators from '../components/Differentiators';
import Products from '../components/Products';
import { Link } from 'react-router-dom';

export default function HomePage() {
  return (
    <>
      <BlueDotsBackground />
      <Hero />
      <HeroVideo />
      {/* <Mdrp id="mdrp"/> taking out for GTN Conference*/}
      <Solutions />
      <Differentiators />
      <Products />
      <div className="flex justify-center space-x-4 mb-16">
        {/* <img src="/soc1.png" alt="SOC1" className="h-[48px]" />
        <img src="/soc2.png" alt="SOC2" className="h-[48px]" /> */}
        <Link to="/contact">
          <button className="w-60 border border-blue-500 text-blue-300 hover:bg-blue-800 font-medium py-3 px-6 rounded-xl transition duration-200">
            Contact Us
          </button>
        </Link>
      </div>
    </>
  );
}
